import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import ServicesCard from './ServicesCard';
import { servicesCategoryMap } from './servicesConstants';
import findKey from 'lodash/findKey';
import { ServiceListLoader } from '../../utils/loaders/ServiceListLoader';

class ServicesList extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.onCardClick = this.onCardClick.bind(this);
    }

    componentDidMount() {
        // console.log('in c=did mount cards');
    }

    onCardClick(label) {
        this.props.actions.filterByServiceByCategory(label);
    }

    // Disabling because this is causing a bug that the services are stuck with the loading animation even after the API data is returned.
    /* shouldComponentUpdate(nextProps){
        if(nextProps.services.availableServices !== this.props.services.availableServices) {
            return true;
        } else {
            return false;
        }

    } */

    get Servicecategories() {
        let { Categories = [], filter = {}, availableServices = [] } = this.props.services;
        if (!Categories || Categories.length <= 0) return <ServiceListLoader />;
        
        let cardRows;
        if (this.props.isMobileView) {
            cardRows = Categories.map((_category) => {
                let _label =
                    findKey(servicesCategoryMap, (item) => item === _category.serviceGroup) ||
                    _category.serviceGroup;
                return (
                    <Button
                        onClick={this.onCardClick.bind(this, _category.serviceGroup)}
                        className={`filter-benefits-button mobile-filter-button font-size-p2 gotham-xn-medium ${
                            _category.serviceGroup === filter.selectedCategory
                                ? 'selected-day-card'
                                : ''
                        }`}>
                        {_label}
                        {_category.serviceGroup === filter.selectedCategory && (
                            <span
                                className="visuallyhidden"
                                role="status">{`${availableServices.length} Results Found`}</span>
                        )}
                    </Button>
                );
            });
        } else {
            cardRows = (
                <fieldset>
                    <legend className="visuallyhidden">Select a Service</legend>
                    <ul
                        aria-label="Filter by Services"
                        className="services-card-list list-style row">
                        {Categories.map((_category) => {
                            let _label =
                                findKey(
                                    servicesCategoryMap,
                                    (item) => item === _category.serviceGroup,
                                ) || _category.serviceGroup;
                            return (
                                <li
                                    className=" button-checkbox col-md-4"
                                    key={_category.serviceGroup}>
                                    <span className="tab-card">
                                        <input
                                            id={_category.serviceGroup}
                                            checked={_label === filter.selectedCategory}
                                            type="checkbox"
                                            onClick={() => this.onCardClick(_label)}
                                        />
                                        <label
                                            htmlFor={_category.serviceGroup}
                                            class="img-responsive-wrapper font-size-p2 gotham-xn-medium">
                                            <ServicesCard
                                                dataId={_category.serviceGroup}
                                                isSelectedCategory={
                                                    _label === filter.selectedCategory
                                                }
                                                onCardClick={() => false}
                                                labelText={_category.serviceGroup}
                                            />
                                        </label>
                                    </span>
                                </li>
                            );
                        })}
                    </ul>
                </fieldset>
            );
        }

        return cardRows;
    }

    render() {
        return (
            <div className="floating-cards white-bg container">
                <h2 className="visuallyhidden">Select a Service Category</h2>
                {this.Servicecategories}
            </div>
        );
    }
}

export default ServicesList;
